import { IWorldObject } from '../IWorldObject';
export class IItem extends IWorldObject {
    constructor(context) {
        super(context);
    }
}
IItem['__class'] = 'de.coco.mindLinq.world.items.IItem';
